import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigOptions, ConfigService } from '@wilson/config';
import { ActivityTemplate } from '@wilson/interfaces';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ActivityTemplatesGateway {
  private readonly httpClient = inject(HttpClient);
  private readonly config = inject<ConfigOptions>(ConfigService);

  public updateActivityTemplate(activityTemplate: Partial<ActivityTemplate>) {
    return firstValueFrom(
      this.httpClient.patch<ActivityTemplate>(
        `${this.config.host}/activity-templates/${activityTemplate.id}`,
        activityTemplate,
      ),
    );
  }
}
